import { IPlatformConfig } from 'lib/src/types';

const obj = require('./platform.pca7');
export const platformConfig: IPlatformConfig = obj.config;
